var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Loader'):_c('div',{staticClass:"content"},[_c('h1',[_vm._v("New customer - Sneak peeks")]),_c('SubscriptionsStatistics',{attrs:{"type":"sneak_peek"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }